export default __webpack_public_path__ + "static/media/handwrite.df2b73de.jpg";